/**
 * created by lei lei
 *更换密码策略
 */
import React from 'react';
import PropTypes from 'prop-types';
import {InputNumber, Button, message} from 'antd';
import SpacerBlock from "../components/spacerBlock/SpacerBlock";
import request from '../../base/request';
import BaseComponent from "../../base/BaseComponent";
import {applicationName} from "../../utils";

let host = `/cm-sites-${applicationName()}/`;

const Apis = {
    getDefaultData: host + 'config/list',
    add:host+'config/add',
    edit:host+'config/edit',
};
export default class ChangePasswordPolicy extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            defaultData: {},
            num: '',
            isAdd: false,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDefaultData();
    }

    getDefaultData() {
        let configKey = 'user.must.update.default.password.loop.time';
        let {config} = this.getInfo();
        let defaultData = config.getConfigByKey(configKey);
        if(defaultData){
            this.setState({
                defaultData,
                num: config.getValueByKey(configKey),
                isAdd: false
            });
        }else{
            this.setState({isAdd: true})
        }
    }

    render() {
        let height = document.body.clientHeight - 70;
        return (
            <div id={'changePasswordPolicy'} style={{padding: 20, height: height}}>
                <div style={{background: '#ffffff', height: height - 40}}>
                    <div style={{height: 56, paddingLeft: 20, lineHeight: '56px', fontSize: 14}}>密码更换策略</div>
                    <SpacerBlock height={1}/>
                    <div style={{padding: 20}}>
                        <InputNumber min={1} value={this.state.num} onChange={(value) => {
                            this.setState({num: value})
                        }}/>
                        天强制更换密码，不填则为永久。 <Button type="primary" onClick={() => {
                        this.save()
                    }}>保存</Button>
                    </div>
                </div>
            </div>
        )
    }

    //保存
    save() {
        if (this.state.isAdd) {
            this.add();
        } else {
            this.edit();
        }
    }

    //如果没有就新增
    add() {
        let params = {
            "configKey": "user.must.update.default.password.loop.time",
            "configValue": this.state.num,
            "defaultValue": this.state.num,
            "id": 0,
            "projectName": "融媒体",
            "configName": "密码更换策略",
            "createBy": "张勋",
            "remark": "单位：天"
        };
        add(params, data => {
            if (data) {
                message.info("设置成功");
                this.refreshConfig(()=>this.getDefaultData());
            }
        })
    }

    //如果有数据就是编辑
    edit() {
        let params = this.state.defaultData;
        params.configValue = this.state.num;
        params.defaultValue = this.state.num;
        edit(params,data => {
            message.info("设置成功");
            this.refreshConfig(()=>this.getDefaultData());
        })
    }


}
export const add = (param, callBack) => {  //保存图片
    request({url:Apis.add,contentType:'json', body:param, method:"post", callBack});
};
export const edit = (param, callBack) => {  //保存图片
    request({url:Apis.edit,contentType:'json', body:param, method:"post", callBack});
};
